/*!

=========================================================
* Layout for Frontend pages (user not logged in)
=========================================================

*/
import React from "react";
// core components
import Footer from "components/Footers/Footer.js";

function FrontendUI({ children }) {
    return (
        <>
            <div className="main-content">
                {children}
                <Footer />
            </div>
        </>
    );
}

export default FrontendUI;
